import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	width: 460px;
	padding: 30px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	box-shadow: 0 6px 80px rgba(0, 0, 0, 0.5);
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
`;

const StyledPriceContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	gap: 10px;
	align-items: center;

	${Text} {
		font-size: 18px;
		color: #ffffff;

		&:nth-child(1) {
			opacity: 0.25;
		}

		&:nth-child(2) {
			font-weight: 700;
		}
	}
`;

const StyledInfoContainer = styled.div`
	width: 100%;
	height: 50px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 10px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledNicknameSummary = styled.div`
	width: 100%;
	min-height: 50px;
	padding: 0 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-top: 20px;

	${Text}:first-of-type {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
		flex-shrink: 0;
	}

	${Text}:last-of-type {
		font-size: 16px;
		color: #ffffff;
		text-align: right;
	}
`;

const StyledReasonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 20px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;

	${Text}:first-of-type {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}

	${Text}:last-of-type {
		font-size: 16px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledGrid,
	StyledHeadContainer,
	StyledInfoContainer,
	StyledModalWrapper,
	StyledNicknameSummary,
	StyledPriceContainer,
	StyledReasonContainer,
};
